export enum ActionPlanColumnsIdEnum {
    TYPE = "type",
    DESCRIPTION = "description",
    DUE_DATE = "due_date",
    STATUS = "status",
    NAME = "name",
    NUMBER = "number",
    ASSIGNEE = "assignee",
}
